<span>{{ timezone }} · {{ displayTime }}</span
>`
